import axios from '../../../../libs/axios'

export function getListBilateralTradeData(rep, year){
  return axios.get(`/get/trade-partners/imports+exports/${rep}?year=${year}&sort=val`,{
    headers:{
      allowed_mirror:1
    }
  })
}

export function getListGlobalTradeData(rep, year, flow){
  return axios.get(`/get/historical-trade/${flow}/${rep}/WLD?year=${year}&sort=val&limit=10`)
}

export function getHSCodeDescription(hs){
  return axios.get(`/get/hs/search?hs=${hs}&v=H4`)
}

export function getListTradePartner(axiosPrivate, rep){
  return axiosPrivate.get(`/dashboard/trade-partners?reporter=${rep}`)
}

export function getListTradePartnerByCommodity(axiosPrivate, params){
  const {rep, hs, tradeflow, year} = params
  return axiosPrivate.get(`/dashboard/trade-partners/${hs}?reporter=${rep}&tradeflow=${tradeflow}&year=${year}`)
}

export function getHistoricalTradeData(axiosPrivate, params){
  const {rep, par, tradeflow} = params
  return axiosPrivate.get(`/dashboard/historical-trade?reporter=${rep}&partner=${par}&tradeflow=${tradeflow}`)
}

export function getCommodities(axiosPrivate, params){
  const {rep, par, tradeflow, hsDigits=6, year} = params
  return axiosPrivate.get(`/dashboard/commodity-list?reporter=${rep}&tradeflow=${tradeflow}&partner=${par}&hs_digits=${hsDigits}&year=${year}`)
}

export function getRTAs(axiosPrivate, params){
  const {rep} = params
  return axiosPrivate.get(`/dashboard/trade-agreements?reporter=${rep}`)
}